import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SurveyGeocoderPageRoutingModule } from './survey-geocoder-routing.module';

import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from 'src/app/components/components.module';
import { SurveyGeocoderModule } from './survey-geocoder.module';
import { SurveyGeocoderPage } from '../device/survey-geocoder.page';
import { SurveyGeocoderBrowserPage } from '../browser/survey-geocoder-browser.page';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    TranslateModule.forChild(),
    SurveyGeocoderPageRoutingModule,
    SurveyGeocoderModule
  ],
  declarations: [SurveyGeocoderPage, SurveyGeocoderBrowserPage]
})
export class SurveyGeocoderPageModule {}
